/**
 * ksaRows - pure helpers for the GLOBAL KSA records (tested in __tests__).
 */

/**
 * Does a KSA row belong to the header's year? Same rule as the main tabs
 * (customer required, year of the quote date), except the year is read off the
 * 'YYYY-MM-DD' string - new Date() reads it as UTC midnight, which moves a
 * 1 January quote into the previous year in US time zones - and a row with no
 * quote date shows in every year instead of vanishing.
 */
export function inYear(row, selectedYear) {
  if (!row || !String(row.customer || '').trim()) return false;
  if (selectedYear === 'all') return true;
  const d = String(row.quoteDate || '').trim();
  if (!d) return true;
  const y = Number(d.slice(0, 4));
  return Array.isArray(selectedYear) ? selectedYear.includes(y) : y === selectedYear;
}

/** The KSA customers, shaped like allAccounts ({ id, name }) for the pickers. */
export function ksaCustomers(rows) {
  return [...new Set((rows || []).map((r) => String(r.customer || '').trim()).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b))
    .map((name) => ({ id: name, name }));
}
